import type { CategoryPageModelProps } from '@/components/catalog/category-page/category-page.model'
import { useCategoryPageModel } from '@/components/catalog/category-page/category-page.model'
import { CategoryPageView } from '@/components/catalog/category-page/category-page.view'

export function CategoryPageViewModel(props: CategoryPageModelProps) {
  const model = useCategoryPageModel(props)
  return <CategoryPageView {...model} />
}
